/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowMindfulnessWorkshopTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowMindfulnessWorkshop,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Find Our Calm!",
    "Mindfulness Workshop Awaits!",
    "Breathe and Relax!",
  ],
  title: "Mindfulness Workshop",
  description: "Organize a peaceful mindfulness workshop.",
  longDescription:
    "Gather your friends for a mindfulness workshop! Choose a date, decide on techniques to practice, and plan activities for relaxation!",
  emoji: "🧘",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Mindfulness Workshop",
          emoji: "🧘",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the mindfulness workshop?",
          emoji: "📅",
          completeAction: {
            question: "Decide on mindfulness techniques to explore?",
            description:
              "What mindfulness techniques should we practice during the workshop?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What techniques should we consider?",
                emoji: "🌼",
                completeAction: {
                  question: "Decide on refreshments?",
                  description:
                    "What refreshments should we have after the workshop?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What refreshments should we bring?",
                      emoji: "🥤",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Find Our Inner Peace!",
    outroDescription:
      "Your mindfulness workshop plans are set! Enjoy the tranquility!",
  },
};
